import useGlobalStore from "app/store";

export default function useAuth() {
  const authToken = useGlobalStore((state) => state?.authToken);
  
  const authHeader = {
    headers: {
      "Authorization": authToken,
    }
  };

  return [ authHeader ] as const;
  
}